module.exports = __webpack_public_path__ + "img/744.85edade5.jpg";